<template>
    <client-page class="wrap--mypage">
        <v-container>
            <div class="mypage-container">
                <!-- 네비게이션 메뉴 -->
                <mypage-navigation></mypage-navigation>
                <!-- 페이지 콘텐츠 -->
                <div class="mypage-contents">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">위탁신청내역</h2>
                    </div>

                    <div class="mypage-contents__body">
                        <v-data-table v-bind="{ ...attrs_table, items, headers }" class="v-data-table--default v-data-table--none-border-left">
                            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                            <template #[`item.reply`]="{item,value}">
                                <v-btn v-if="!value" :to="`/mypage/consignment-list/${item._id}`" small outlined width="80" height="26" color="grey-cb" style="background-color:#efefef !important;"><span class="grey-68--text">확인</span></v-btn>
                                <v-btn v-if="value" :to="`/mypage/consignment-list/${item._id}`" small width="80" height="26" color="primary">처리완료</v-btn>
                            </template>
                        </v-data-table>

                        <div class="v-pagination-wrap">
                            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="my-4" @input="search()" />
                        </div>

                        <v-fade-transition>
                            <v-overlay v-show="loading" absolute color="white" light>
                                <v-progress-circular size="100" width="2" indeterminate color="primary" />
                            </v-overlay>
                        </v-fade-transition>
                    </div>
                </div>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import MypageNavigation from "@/components/client/ko/mypage-navigation.vue";
import { attrs_table } from "@/assets/variables";
import api from "@/api";
const headers = [
    { align: "center", text: "번호", value: "index" },
    { align: "center", text: "작가명", value: "meta.author" },
    { align: "center", text: "작품명", value: "meta.subject" },
    { align: "center", text: "작성일", value: "createdAt", formatter: (value) => value.toDate() },
    { align: "center", text: "상태", value: "reply" },
];

export default {
    components: {
        ClientPage,
        MypageNavigation,
    },
    data() {
        return {
            loading: false,
            attrs_table,
            headers,

            page: +this.$route.query.page || 1,
            totalCount: 0,
            limit: 10,

            filter: {},

            forms: [],
        };
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        items() {
            return (this.forms || []).map((item, index) => ({ ...item, index: +this.totalCount - (+this.page - 1) * +this.limit - index }));
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (!this.accessToken) {
                this.$router.push({
                    path: "/login",
                    params: this.$router.params,
                });
            }
            this.search(false);
        },

        async search(routable = true) {
            this.loading = true;
            const { page, limit, skip } = this;
            if (routable) this.$router.push({ query: Object.assign({}, this.filter, { page }) });

            var {
                summary: { totalCount },
                forms,
            } = await api.v1.forms.gets({
                headers: { skip, limit },
                params: { ...this.filter, isMine: true, code: "consignment-sale" },
            });

            this.forms = forms;
            this.totalCount = totalCount;

            this.loading = false;
        },
    },
};
</script>
